import React, { useEffect } from 'react';
import './About.css';

const About = () => {
    useEffect(() => {
        document.title = 'About Us | Avenis Global';
    }, []);

    return (
        <div className="about-page">
            <div className="about-hero">
                <div className="container">
                    <h1>About Us</h1>
                    <p>
                        Avenis is your new avenue to smarter selling. Authorized
                        retail partnership with 100% MAP compliance, brand-safe
                        content, and transparent operations across premium
                        e-commerce channels.
                    </p>
                </div>
            </div>

            <div className="container">
                <div className="about-content">
                    <div className="about-text">
                        <h2>
                            <span className="dashboard-title-text">Our</span>
                            <span className="dashboard-title-highlight">
                                {' '}
                                Story
                            </span>
                        </h2>
                        <p>
                            Avenis Global was founded as an authorized retail
                            partnership company focused on MAP compliance and
                            brand protection. With over{' '}
                            {new Date().getFullYear() - 2018} years of
                            experience, our mission is to help brands maximize
                            their authorized retail performance while
                            maintaining complete brand integrity across all
                            e-commerce channels.
                        </p>
                        <p>
                            We've built our entire operation around protecting
                            your brand integrity while maximizing authorized
                            retail performance. Inventory, compliance, and
                            marketing handled. You focus on your product; we
                            scale your sales.
                        </p>
                    </div>
                    <div className="about-dashboard">
                        <div className="hero-dashboard">
                            <div className="dashboard-header">
                                <h2 className="dashboard-title">
                                    <span className="dashboard-title-highlight">
                                        Avenis Global
                                    </span>
                                    <span className="dashboard-title-text">
                                        {' '}
                                        in Numbers
                                    </span>
                                </h2>
                            </div>

                            <div className="dashboard-stats-enhanced">
                                <div className="stat-card-enhanced">
                                    <div className="stat-icon stat-icon-1">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                            <circle
                                                cx="9"
                                                cy="7"
                                                r="4"
                                            ></circle>
                                            <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                        </svg>
                                    </div>
                                    <div className="stat-content">
                                        <h3 className="stat-number">40+</h3>
                                        <p className="stat-label">
                                            Premium Brands
                                        </p>
                                        <div className="stat-trend">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="10"
                                                height="10"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M3 3v18h18"></path>
                                                <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                                            </svg>
                                            <span>+12%</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="stat-card-enhanced">
                                    <div className="stat-icon stat-icon-2">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M9 12l2 2 4-4"></path>
                                            <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.5 0 2.91.37 4.15 1.02"></path>
                                            <path d="M16 2l4 4-4 4"></path>
                                        </svg>
                                    </div>
                                    <div className="stat-content">
                                        <h3 className="stat-number">0</h3>
                                        <p className="stat-label">
                                            MAP Violations
                                        </p>
                                        <div className="stat-trend">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="10"
                                                height="10"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M9 12l2 2 4-4"></path>
                                                <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.5 0 2.91.37 4.15 1.02"></path>
                                                <path d="M16 2l4 4-4 4"></path>
                                            </svg>
                                            <span>Perfect Score</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="stat-card-enhanced">
                                    <div className="stat-icon stat-icon-3">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M9 11H5a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h4"></path>
                                            <path d="M15 11h4a2 2 0 0 1 2 2v3c0 1.1-.9 2-2 2h-4"></path>
                                            <path d="M9 7h6v4H9z"></path>
                                            <path d="M9 3h6v4H9z"></path>
                                        </svg>
                                    </div>
                                    <div className="stat-content">
                                        <h3 className="stat-number">500+</h3>
                                        <p className="stat-label">Projects</p>
                                        <div className="stat-trend">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="10"
                                                height="10"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M3 3v18h18"></path>
                                                <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                                            </svg>
                                            <span>+25%</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="stat-card-enhanced">
                                    <div className="stat-icon stat-icon-4">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                                            <path d="M2 17l10 5 10-5"></path>
                                            <path d="M2 12l10 5 10-5"></path>
                                        </svg>
                                    </div>
                                    <div className="stat-content">
                                        <h3 className="stat-number">
                                            {new Date().getFullYear() - 2018}+
                                        </h3>
                                        <p className="stat-label">
                                            Years Experience
                                        </p>
                                        <div className="stat-trend">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="10"
                                                height="10"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M9 12l2 2 4-4"></path>
                                                <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.5 0 2.91.37 4.15 1.02"></path>
                                                <path d="M16 2l4 4-4 4"></path>
                                            </svg>
                                            <span>Since 2018</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="values-section">
                    <h2>
                        <span className="dashboard-title-text">Our</span>
                        <span className="dashboard-title-highlight">
                            {' '}
                            Values
                        </span>
                    </h2>
                    <div className="values-grid">
                        <div className="value-item">
                            <div className="value-item-bg"></div>
                            <div className="value-icon">🎯</div>
                            <h4>Focus</h4>
                            <p>
                                We achieve the best results by focusing on
                                customer goals.
                            </p>
                        </div>
                        <div className="value-item">
                            <div className="value-item-bg"></div>
                            <div className="value-icon">🚀</div>
                            <h4>Innovation</h4>
                            <p>
                                We make a difference with continuous development
                                and innovative solutions.
                            </p>
                        </div>
                        <div className="value-item">
                            <div className="value-item-bg"></div>
                            <div className="value-icon">🤝</div>
                            <h4>Trust</h4>
                            <p>
                                We build reliable partnerships with principles
                                of transparency and honesty.
                            </p>
                        </div>
                        <div className="value-item">
                            <div className="value-item-bg"></div>
                            <div className="value-icon">⭐</div>
                            <h4>Quality</h4>
                            <p>
                                We ensure customer satisfaction by providing
                                services at the highest standards.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
